module.exports = __webpack_public_path__ + "img/tasks_yellow.3053e8cd.png";